export default class NavigationScrollHandler {
  constructor({ scrollDistance = 100, onEnter = () => {}, onExit = () => {}, scrollDown = () => {}, scrollUp = () => {}, headerElement = false, mainNav = false } = {}) {
    this.onEnter = onEnter;
    this.onExit = onExit;
    this.scrollDown = scrollDown;
    this.scrollUp = scrollUp;
    this.scrollDistance = scrollDistance;
    this.headerElement = headerElement;
    this.mainNav = mainNav;
    this.visibleAdminBar = document.querySelector('body.admin-bar');
    this.lastKnownScrollY = 0;
    this.ticking = false;
    this.lastScrollTop = 0;

    this.onScroll();
    this.addListeners();
  }

  addListeners() {
    window.addEventListener('scroll', () => this.onScroll(), false);

    if (this.headerElement) {
      window.addEventListener('resize', () => this.wpAdminBarResize(), false);
    }
  }

  onScroll() {
    this.lastKnownScrollY = window.pageYOffset;
    this.requestTick();
  }

  requestTick() {
    if(!this.ticking) {
      requestAnimationFrame(this.update.bind(this));
    }

    this.ticking = true;
  }

  update() {
    let currentScrollY = this.lastKnownScrollY;
    this.ticking = false;

    this.checkScrollDistance(currentScrollY);
    this.wpAdminBar(currentScrollY);
  }

  checkScrollDistance(scrolledDistance) {

    // Scrolling up or down
    if (scrolledDistance > this.lastScrollTop && scrolledDistance >= this.scrollDistance){
      this.scrollDown();
    } else {
      this.scrollUp();
    }
    this.lastScrollTop = scrolledDistance <= 0 ? 0 : scrolledDistance;

    // Scrolling beyond scroll distance
    if (this.scrollDistance >= 1) {
      if (scrolledDistance > this.scrollDistance) {
        this.onEnter();
      } else if (scrolledDistance < this.scrollDistance) {
        this.onExit();
      }
    }
  }

  wpAdminBar(scrolledDistance) {
    if (!this.headerElement) {
      return false;
    }

    const ADMIN_BAR_HEIGHT = 46;
    const HEADER_HEIGHT = this.headerElement.getBoundingClientRect().height;

    if (window.innerWidth < 601 && this.visibleAdminBar) {
      let topNumber = ADMIN_BAR_HEIGHT - scrolledDistance;

      if (scrolledDistance >= ADMIN_BAR_HEIGHT) {
        this.headerElement.style.top = 0;
        
        if (this.mainNav) {
          this.mainNav.style.top = `${HEADER_HEIGHT}px`;
          this.mainNav.style.height = `calc(100% - ${HEADER_HEIGHT}px)`;
        }
      } else {
        this.headerElement.style.top = `${topNumber}px`;
        
        if (this.mainNav) {
          this.mainNav.style.top = `calc(${topNumber}px + ${HEADER_HEIGHT}px)`;
          this.mainNav.style.height = `calc(100% - (${topNumber}px + ${HEADER_HEIGHT}px))`;
        }
      }
    }
  }

  wpAdminBarResize() {
    if (window.innerWidth > 600) {
      this.headerElement.style.top = '';
      if (this.mainNav) {
        this.mainNav.style.top = '';
        this.mainNav.style.height = '';
      }
    } else {
      this.wpAdminBar(this.lastKnownScrollY);
    }
  }
}